import { modalEvents } from '@/shared/constants/constants';

const getBuyNowPayLaterModal = () => {
  const modalElement = document.querySelector(
    'hb-modal#js-buy-now-pay-later-modal'
  );
  if (!modalElement || !modalElement.shadowRoot) return;

  return modalElement.shadowRoot.querySelector('#js-buy-now-pay-later-modal');
};

const closeBuyNowPayLaterModal = () => {
  const buyNowPayLater = getBuyNowPayLaterModal();
  if (!buyNowPayLater) return;

  window.removeEventListener('keydown', closeBuyNowPayLaterModalOnEscape);
  buyNowPayLater.dispatchEvent(new CustomEvent(modalEvents.close));
};

const closeBuyNowPayLaterModalOnEscape = (event) => {
  if (event.key === 'Escape') {
    closeBuyNowPayLaterModal();
  }
};

const openLoginModal = () => {
  const returnTo = encodeURIComponent(
    window.location.pathname + window.location.search + window.location.hash
  );
  window.location.href = `/customer_authentication/login?return_to=${returnTo}`;
};

const initBuyNowPayLaterModal = () => {
  const btnBuyNowPayLater = document.querySelector(
    '.js-buy-now-pay-later-button'
  );

  if (btnBuyNowPayLater) {
    btnBuyNowPayLater.addEventListener('click', (event) => {
      event.preventDefault();
      openBuyNowPayLaterModal();
    });
  }
};

const removeHiddenClassFromBuyNowPayLaterModal = () => {
  const buyNowPayLater = document.querySelector('#js-buy-now-pay-later-modal');
  if (buyNowPayLater && buyNowPayLater.classList.contains('hidden')) {
    buyNowPayLater.classList.remove('hidden');
  }
};

const openBuyNowPayLaterModal = () => {
  if (!('customElements' in window)) return;

  const buyNowPayLater = getBuyNowPayLaterModal();
  if (!buyNowPayLater) return;

  window.addEventListener('keydown', closeBuyNowPayLaterModalOnEscape);
  buyNowPayLater.dispatchEvent(new CustomEvent(modalEvents.open));
};

export {
  initBuyNowPayLaterModal,
  openLoginModal,
  removeHiddenClassFromBuyNowPayLaterModal
};
